import httpService from '@/modules/common/services/httpService';

const basePlatformRoute = '/platform/v1/scheduling';

const fetchEventAttendances = async (uids, matterUid, clientUid, perPage = 25) => {
  // Input validation
  if (!Array.isArray(uids) || uids.length === 0) {
    throw new Error('uids must be a non-empty array');
  }

  if (!clientUid) {
    throw new Error('clientUid is required');
  }

  try {
    const response = await httpService.get(`${basePlatformRoute}/event_attendances`, {
      uids: uids.join(','),
      matter_uid: matterUid,
      client_uid: clientUid,
      per_page: perPage,
    });

    return response.data?.data?.event_attendances || [];
  } catch (error) {
    console.error('Error fetching event attendances:', error);
    throw error; // Re-throw for caller to handle
  }
};

export default {
  fetchEventAttendances,
};
